const fileMixin = {
  methods: 
  {
    getIcon(file, icon='mdi-file-check-outline')
    {
        let extension = file.split('.').pop()

        switch( extension.toLowerCase() )
        {
            case 'png':
            case 'jpg':
            case 'jpeg':
            case 'gif':
                    icon = 'mdi-image'
                break;
            case 'ai':
            case 'eps':
                    icon = 'mdi-vector-curve'
                break;
            case 'doc':
            case 'docx':
                    icon = 'mdi-microsoft-word'
                break;
            case 'ppt':
            case 'pptx':
                    icon = 'mdi-microsoft-powerpoint'
                break;
            case 'xls':
            case 'xlsx':
                    icon = 'mdi-microsoft-excel'
                break;
            case 'pdf':
                    icon = 'mdi-file-pdf-box'
                break;
            case 'zip':
                    icon = 'mdi-folder-zip-outline'
                break;
        }

        return icon
    },

    getFilename(file)
    {
        let filename = file.split('-')

        filename.shift()

        return filename.join('-')
    },
  },

  computed:
  {

  },

  watch:
  {
    
  }
}

export default fileMixin